<template>
  <div class="all-videos">
    <h1>{{ title }}</h1>
    <hr><br />
    <vimeo-videos
      :per_page="perPage"
      :page="$route.params.page"
      :scope="scope"
      @onSuccess="setTotal"
    >
      <template slot-scope="props">
        <div class="row auto-clear">
          <article class="col-lg-3 col-md-6 col-sm-4" v-for="video in props.videos">
            <single-video :video="video"></single-video>
          </article>
        </div>
      </template>
      <div class="clearfix spacer"></div>
    </vimeo-videos>
    <div class="row">
      <div class="col-md-6">
        <router-link :to="{ name: 'AllVideos', params: { page: $route.params.page - 1 } }" class="btn btn-primary btn-lg" v-if="total > 0 && $route.params.page > 1">
          Page précédente
        </router-link>
      </div>
      <div class="col-md-6 text-right">
        <router-link :to="{ name: 'AllVideos', params: { page: $route.params.page + 1 } }" class="btn btn-primary btn-lg" v-if="perPage * $route.params.page < total">
          Page suivante
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import { startCase } from 'lodash';
  import { VimeoVideos } from 'itrnews-vuejs-api';
  import SingleVideo from './elements/Singlevideo';

  export default {
    components: { VimeoVideos, SingleVideo },
    name: 'AllVideos',
    methods: {
      setTotal(response) {
        this.total = response.total;
      },
      getTitle(title) {
        return startCase(title);
      },
    },
    computed: {
      title() {
        return startCase(this.$route.params.title);
      },
      scope() {
        const type = this.$route.params.type;
        if (this.scopes[type]) {
          return `${this.scopes[type]}${this.$route.params.id || ''}`;
        }

        return null;
      },
    },
    data() {
      return {
        total: 0,
        perPage: 21,
        scopes: {
          portfolios: 'users/itrnews/portfolios/',
          albums: 'albums/',
          last: 'users/itrnews',
        },
      };
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/AllVideos.vue